import {getAllQuizResults} from "../services/quizResults";

export const getQuizResultList = () => dispatch => {
    dispatch({
        type: 'GET_QUIZ_RESULT_START',
        payload: {}
    });
    getAllQuizResults().then((data) => {
        // handle success
            dispatch( {
                type: 'GET_QUIZ_RESULT_SUCCESS',
                payload: data
            });
        })
        .catch((error) => {
            // handle error
            if (error.data) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(error.status);
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
            let errorObj = error.data? error.data.error: {};
            dispatch({
                type: 'GET_QUIZ_RESULT_FAIL',
                payload: {
                    error : errorObj
                }
            });
        })
};
